$(document).ready(function() {
  $.get(
    "https://ipinfo.io?token=cd65e5132b5b67",
    function(response) {
      console.log(response.ip, response.country);
      if (response.country == "CN") {
        var $contact = $(".contact_link");
        var $contactcn = $(".contactcn_link");
        $contact.click(function(e) {
          e.preventDefault();
          window.location.replace("/contactcn.html");
        });
        $contactcn.click(function(e) {
          e.preventDefault();
          window.location.replace("/cn/contactcn.html");
        });
      } else if (response.country == "HK") {
        var $contact = $(".contact_link");
        var $contactcn = $(".contactcn_link");
        $contact.click(function(e) {
          e.preventDefault();
          window.location.replace("/contacthk.html");
        });
        $contactcn.click(function(e) {
          e.preventDefault();
          window.location.replace("/cn/contacthk.html");
        });
      }
    },
    "jsonp"
  );
  // contact redirect

  //Close Popup
  var $popup = $(".popup-container");
  var $popupBtn = $(".close-btn");
  $popupBtn.click(function(e) {
    $popup.fadeOut(200);
    e.preventDefault();
  });
  //Mobile Navigation Toggle
  var $menuToggle = $(".hamburger");
  var $nav = $("nav");

  $menuToggle.click(function(e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).toggleClass("is-active");
    $nav.toggleClass("is-open");
  });

  //Phase Selector Toggle
  var $controller = $("#phase-controller");
  var $phases = $("#phases");

  if ($(window).width() > 1090) {
    $controller.click(function(e) {
      e.preventDefault();
      e.stopPropagation();
      $phases.toggleClass("is-open");
    });
    $("html").click(function() {
      $phases.removeClass("is-open");
    });
  } else {
    $controller.click(function() {
      $phases.slideToggle(300);
    });
  }

  //Hero slider
  $(".hero-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    asNavFor: ".title-wrapper"
  });
  $(".title-wrapper").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    asNavFor: ".hero-slider",
    dots: true,
    arrows: false,
    infinite: true,
    fade: true,
    adaptiveHeight: true,
    customPaging: function(slider, i) {
      return '<a href="#"><div class="paging"></div></a>';
    },
    nextArrow:
      "<img class='arrow-right' src='../images/icons/arrow-right.png'>",
    prevArrow: "<img class='arrow-left' src='../images/icons/arrow-left.png'>"
  });

  $(".hero-slider").on("afterChange", function(event, slick, currentSlide) {
    $(".slide").removeClass("animated");
    $(".slide.slick-slide.slick-current").addClass("animated");
  });

  //Site Map Interaction
  var $mapSelector = $(".marker");

  $mapSelector.click(function() {
    $(this).toggleClass("active");
    var toggle_id = $(this).attr("data-toggle");
    $("." + toggle_id).toggleClass("active");
  });

  // Mouse Scroll Fadeout

  $(window).scroll(function() {
    var $wScroll = $(this).scrollTop();
    var $mouse = $(".scroll-btn");

    if ($wScroll > $(".section-hero-image").offset().top) {
      $mouse.fadeOut();
    }
  });

  //Pano view
  var $view = $(".view-link");
  var $controllerDiv = $(".view-controller");
  $view.click(function() {
    $controllerDiv.fadeOut();
    var view_id = $(this).attr("data-link");
    $("#" + view_id).addClass("active");
  });

  //Back Button
  var $back = $(".back-btn");
  var $pano = $(".view-content");
  $back.click(function() {
    $pano.removeClass("active");
    $controllerDiv.fadeIn();
  });

  // Animate Panorama photo
  $(".pano").cyclotron({ dampingFactor: 1, autorotation: 1 });
});

// Video Function

var $video1 = $(".video-1");
var $video2 = $(".video-2");

$video1.on("ended", function() {
  $(this).hide();
  $video2.get(0).play();
});

// Google Map
function initMap() {
  var concord = { lat: 49.2277399, lng: -122.9997942 };
  var map = new google.maps.Map(document.getElementById("map"), {
    zoom: 14,
    scaleControl: false,
    scrollwheel: false,
    center: concord
  });
  var marker = new google.maps.Marker({
    position: concord,
    map: map
  });

  var styles = [
    {
      featureType: "administrative",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#6195a0"
        }
      ]
    },
    {
      featureType: "landscape",
      elementType: "all",
      stylers: [
        {
          color: "#f2f2f2"
        }
      ]
    },
    {
      featureType: "landscape",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#ffffff"
        }
      ]
    },
    {
      featureType: "poi",
      elementType: "all",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "poi.park",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#e6f3d6"
        },
        {
          visibility: "on"
        }
      ]
    },
    {
      featureType: "road",
      elementType: "all",
      stylers: [
        {
          saturation: -100
        },
        {
          lightness: 45
        },
        {
          visibility: "simplified"
        }
      ]
    },
    {
      featureType: "road.highway",
      elementType: "all",
      stylers: [
        {
          visibility: "simplified"
        }
      ]
    },
    {
      featureType: "road.highway",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#f4d2c5"
        },
        {
          visibility: "simplified"
        }
      ]
    },
    {
      featureType: "road.highway",
      elementType: "labels.text",
      stylers: [
        {
          color: "#4e4e4e"
        }
      ]
    },
    {
      featureType: "road.arterial",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#f4f4f4"
        }
      ]
    },
    {
      featureType: "road.arterial",
      elementType: "labels.text.fill",
      stylers: [
        {
          color: "#787878"
        }
      ]
    },
    {
      featureType: "road.arterial",
      elementType: "labels.icon",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "transit",
      elementType: "all",
      stylers: [
        {
          visibility: "off"
        }
      ]
    },
    {
      featureType: "water",
      elementType: "all",
      stylers: [
        {
          color: "#eaf6f8"
        },
        {
          visibility: "on"
        }
      ]
    },
    {
      featureType: "water",
      elementType: "geometry.fill",
      stylers: [
        {
          color: "#eaf6f8"
        }
      ]
    }
  ];

  map.setOptions({
    styles: styles
  });
}
